import React from "react";
import PropTypes from "prop-types";
import BaseBlock from "./BaseBlock";
import useBlockData from "./useBlockData";
import FlexTable from "../../../components/ui-components/FlexTable";
import { fmtEur } from "./format";

// Columns for the month-by-month forward forecast: money is float euros (fmtEur takes euros
// directly — this figure follows forecast_band/horizon, NOT the cents convention).
const columns = [
  { Header: "Month", accessor: "label" },
  { Header: "Expected", accessor: "expected", align: "right", Cell: ({ value }) => fmtEur(value) },
  { Header: "Best", accessor: "best", align: "right", Cell: ({ value }) => fmtEur(value) },
  { Header: "Worst", accessor: "worst", align: "right", Cell: ({ value }) => fmtEur(value) },
  { Header: "Budget", accessor: "budget", align: "right", Cell: ({ value }) => fmtEur(value) },
];

/**
 * ForecastMonthlyTableBlock - month-by-month forward forecast (forecast_monthly_table block type),
 * complementing the near-term 30/60/90 horizon_table on the Forecast Table page.
 *
 * GET /api/v1/board-reports/{boardReportId}/runs/{runId}/figures/forecast-monthly -> envelope key
 * "forecast_monthly" -> boardfigures.MonthlyForecast { rows: [MonthlyForecastRow] } — one row per
 * full forward month with Expected (forecast) / Best (lower band) / Worst (upper band) / Budget.
 */
const ForecastMonthlyTableBlock = ({ title = "Monthly forecast", boardReportId, runId }) => {
  const { data, isLoading, error } = useBlockData(
    `/api/v1/board-reports/${boardReportId}/runs/${runId}/figures/forecast-monthly`
  );

  const rows = data?.forecast_monthly?.rows ?? [];

  return (
    <BaseBlock title={title} isLoading={isLoading} error={error} className="a4-forecast-monthly-table">
      {rows.length > 0 ? (
        <FlexTable columns={columns} data={rows} getRowId={(row) => row.month} />
      ) : (
        <p className="a4-empty-note" style={{ color: "#6b6b6b", fontSize: "9pt", margin: "2mm 0" }}>
          No forward months in the forecast range.
        </p>
      )}
    </BaseBlock>
  );
};

ForecastMonthlyTableBlock.propTypes = {
  title: PropTypes.string,
  boardReportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  runId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ForecastMonthlyTableBlock;
